import { Input } from 'antd5';
import styled from 'styled-components';

import { None } from 'components/data/helpers/helpers';

export { CustomFilterPopover } from './filterPopover.style';

// Filter Dropdown Components for range sliders and dates
export const CustomFilterContainer = styled.div`
  padding: 0.5rem;

  > .ant-radio-group {
    display: flex;
    width: 100%;

    > .ant-radio-button-wrapper {
      display: flex;
      flex-grow: 1;
      justify-content: center;
    }
  }
`;

// Text search for narrowing the checkbox options in a column filter.
export const FilterSearchInput = styled(Input)`
  && .ant-input-suffix {
    color: ${({ theme }) => theme.secondaryTextColor};
  }

  && .ant-input-suffix .anticon-search {
    pointer-events: none;
  }

  && .ant-input-clear-icon {
    color: ${({ theme }) => theme.secondaryTextColor};

    &:hover {
      color: ${({ theme }) => theme.headerColor};
    }
  }
`;

export const NoneCheckboxContainer = styled.div`
  border-top: 1px solid #f0f0f0;
  border-bottom: 1px solid #f0f0f0;
`;

export const SecondaryFilterLabel = styled.p`
  color: ${({ theme }) => theme.secondaryTextColor};
  margin-bottom: 0.25rem;
`;

export const InputNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;

  > div:nth-of-type(1) {
    margin-right: '1rem';
  }
  > div:nth-of-type(1) {
    margin-left: '1rem';
  }
`;

export const InputNumberLabel = styled.p`
  margin-bottom: 0.25rem;
`;

// SelectAll stylings
export const Container = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
`;

export const ConditionalFiltersDivider = styled.hr`
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.borderColor};
  margin: 0;
`;

export const ConditionalFiltersLabel = styled.div`
  color: ${({ theme }) => theme.secondaryTextColor};
  font-weight: 600;
  padding: 8px 12px 4px;
`;

export const EmptyConditionalFiltersText = styled.em`
  color: ${({ theme }) => theme.secondaryTextColor};
  display: block;
  font-style: italic;
  padding: 5px 12px;
`;

export const ListItem = styled.div<{ $checked?: boolean }>`
  display: flex;
  padding: 5px 12px;
  color: ${({ $checked, theme }) => ($checked ? theme.teal : theme.headerColor)};

  &:hover {
    background-color: ${({ theme }) => theme.selectedListItemBackground};
    cursor: pointer;
  }

  > button {
    padding-left: 0;

    &:hover {
      background-color: unset !important;
    }
  }
`;

export const Text = styled.div`
  padding-left: 5px;
`;

export const BoldText = styled.div`
  padding-left: 5px;
  font-weight: bold;
`;

export const NoneText = styled(None)`
  padding-left: 5px;
`;

// Select styling
export const SelectContainer = styled.div`
  display: flex;
  > .ant-select {
    width: 100%;
  }
`;
